<template>
  <div class="dataPresentation-container">
    <dv-border-box-8 :dur="60">
      <div class="content">
        <h2>{{ title }}</h2>
        <div class="parameter">
          <p><count-to
              :startVal='startVal'
              :endVal='number'
              :duration='duration'
            ></count-to></p>
          <span class="unit">双</span>
        </div>
      </div>
    </dv-border-box-8>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';

export default {
  name: 'DataPresentation',
  props: {
    title: String,
    number: Number
  },
  components: {
    CountTo
  },
  data () {
    return {
      startVal: 0,
      duration: 1000
    }
  },
  watch: {
    'number': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.startVal = oldVal
        setTimeout(() => { this.duration = 20 * 1000 }, 1000)
      }
    },
  }
}
</script>

<style scoped>
.dataPresentation-container {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
}

.parameter {
  display: flex;
  align-items: flex-end;
}

h2 {
  font-size: 30px;
  text-align: left;
  line-height: 30px;
  width: 100%;
  padding-left: 22px;
}

p {
  color: rgb(239, 176, 64);
  font-size: 120px;
  font-weight: bold;
  text-shadow: 2px 2px 5px red;
}

.unit {
  font-weight: bold;
  font-size: 30px;
  padding-bottom: 20px;
}
</style>
